module.exports = __webpack_public_path__ + "static/iemelianova-4fae089b04c8d786c4b8816a2a296839.jpg";